export enum NavigationBoxMode {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED'
}
